"use client";

import { c as _c } from "react/compiler-runtime";
import { FileText, FlaskConical, Lightbulb, X } from "lucide-react";
import type { MentionReference } from "@/lib/mentions/types";
import { cn } from "@/lib/utils";
const ICON_BY_TYPE = {
  document: FileText,
  insight: Lightbulb,
  experiment: FlaskConical,
  user: FileText,
  assumption: FileText,
  hypothesis: FileText,
  learning: FileText
} as const;
export interface LaunchContextChipProps {
  mention: MentionReference;
  onRemove?: () => void;
  disabled?: boolean;
  className?: string;
}

/**
 * Chip for a launch-context mention (project home intent field).
 */
export function LaunchContextChip(t0) {
  const $ = _c(15);
  const {
    mention,
    onRemove,
    disabled: t1,
    className
  } = t0;
  const disabled = t1 === undefined ? false : t1;
  const Icon = ICON_BY_TYPE[mention.type] ?? FileText;
  let t2;
  if ($[0] !== className) {
    t2 = cn("inline-flex max-w-full items-center gap-1 rounded-md bg-muted/70 px-2 py-0.5 text-xs text-foreground", className);
    $[0] = className;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== Icon) {
    t3 = <Icon className="size-3 shrink-0 text-muted-foreground" aria-hidden={true} />;
    $[2] = Icon;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== mention.label) {
    t4 = <span className="truncate">{mention.label}</span>;
    $[4] = mention.label;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== disabled || $[7] !== mention.label || $[8] !== onRemove) {
    t5 = onRemove ? <button type="button" onClick={onRemove} disabled={disabled} className="shrink-0 rounded p-0.5 text-muted-foreground hover:text-foreground disabled:opacity-40" aria-label={`Remove ${mention.label}`}><X className="size-3" aria-hidden={true} /></button> : null;
    $[6] = disabled;
    $[7] = mention.label;
    $[8] = onRemove;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== t2 || $[11] !== t3 || $[12] !== t4 || $[13] !== t5) {
    t6 = <span className={t2}>{t3}{t4}{t5}</span>;
    $[10] = t2;
    $[11] = t3;
    $[12] = t4;
    $[13] = t5;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  return t6;
}